import { type InferType, array, boolean, object, string } from "yup";

export const objectiveSchema = object({
  _id: string().required(),
  name: string().required(),
});

export const approachSchema = object({
  _id: string().required(),
  label: string().required(),
  value: string().required(),
  active: boolean().required(),
  createdAt: string().required(),
  updatedAt: string().required(),
});

export const challengeSchema = object({
  _id: string().required(),
  name: string().required(),
  icon: string().required(),
  tags: array(string().required()).required(),
  objectives: array(objectiveSchema),
  favoriteOffers: array(string()),
  approaches: array(approachSchema).default([]),
});

export type TChallengeResolver = InferType<typeof challengeSchema>;
